// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import Layout from '../components/common/Layout';

import { routes as AuthRoutes, redirects as AuthRedirects } from './auth';
import { routes as ErrorsRoutes, redirects as ErrorsRedirects } from './errors';
import { routes as SettingsRoutes, redirects as SettingsRedirects } from './settings';

import { routes as AlarmsRoutes, redirects as AlarmsRedirects } from './alarms';
import { routes as ConfigurationRoutes, redirects as ConfigurationRedirects } from './configuration';
import { routes as DashboardRoutes, redirects as DashboardRedirects } from './dashboard';
import { routes as ManagementRoutes, redirects as ManagementRedirects } from './management';
import { routes as SensorsRoutes, redirects as SensorsRedirects } from './sensors';

const renderRoutes = (routes: any[]): JSX.Element[] => {
  return routes.map((props: any) => {
    return <Route exact {...props} key={`path_${props.path}`} />;
  });
};

const renderRedirects = (redirects: any[]): JSX.Element[] => {
  return redirects.map((props: any) => {
    return (
      <Route exact path={props.from} key={`path_${props.from}_${props.to}`} render={(): JSX.Element => <Redirect to={props.to} />} />
    );
  });
};

const renderAllRoutes = (allRoutes: any[]): JSX.Element[][] => {
  return allRoutes.map((routes: any[]): JSX.Element[] => {
    return renderRoutes(routes);
  });
};

const renderAllRedirects = (allRedirects: any[]): JSX.Element[][] => {
  return allRedirects.map((redirects: any[]): JSX.Element[] => {
    return renderRedirects(redirects);
  });
};

const allRoutes: any[] = [
  AuthRoutes,
  ErrorsRoutes,
  SettingsRoutes,
  AlarmsRoutes,
  ConfigurationRoutes,
  DashboardRoutes,
  ManagementRoutes,
  SensorsRoutes,
];

const allRedirects: any[] = [
  AuthRedirects,
  ErrorsRedirects,
  SettingsRedirects,
  AlarmsRedirects,
  ConfigurationRedirects,
  DashboardRedirects,
  ManagementRedirects,
  SensorsRedirects,
];

const routes: JSX.Element = (
  <div>
    <Switch>
      {renderRoutes(AuthRoutes)}
      <Layout>
        {renderAllRedirects(allRedirects)}
        {renderAllRoutes(allRoutes)}
        <Route exact path="/" key="path_/" render={(): JSX.Element => <Redirect to="/dashboard" />} />
      </Layout>
    </Switch>
  </div>
);

export default routes;
